let ManualOrders = {
    attendeesCount: 0,

    init: function () {
        this.bind();
    },

    bind: function () {
        this.form();
        this.addAttendee();
        this.removeAttendee();
    },

    form: function () {
        let _this = this;
        const manualOrderForm = $('#manualOrderForm');

        if (manualOrderForm.length) {
            let submitBtn = Ladda.create(manualOrderForm.find('[type=submit]')[0]);

            manualOrderForm.ajaxForm({
                beforeSubmit: function () {
                    $('.form-group').removeClass('has-error');
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        toastr.success(response.message);
                        setTimeout(() => {
                            window.location.assign('/manual-orders');
                        }, 1000);
                    } else {
                        submitBtn.stop();
                        toastr.error(response.message);
                    }
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });
        }

        const elem = $('#usersAutocomplete')
        elem.select2({
            ajax: {
                url: '/manual-orders/users/autocomplete',
                dataType: 'json',
                processResults: function (data) {
                    return {
                        results: data.items
                    };
                },
            },

            placeholder: 'Select User ...',
            minimumInputLength: 3,
        });
    },

    addAttendee() {
        let _this = this;
        $(document).on('click', '#addAttendee', () => {
            const container = $('#attendeesContainer');
            _this.attendeesCount++;
            const html = '<div class="form-group row attendee">\n' +
                '                               <div class="col-sm-2">\n' +
                '                                    <label>First Name</label>\n' +
                '                                    <input type="text" name="attendees[' + _this.attendeesCount + '][first_name]" class="form-control" required>\n' +
                '                                </div>\n' +
                '                                <div class="col-sm-2">\n' +
                '                                    <label>Last Name</label>\n' +
                '                                    <input type="text" name="attendees[' + _this.attendeesCount + '][last_name]" class="form-control" required>\n' +
                '                                </div>\n' +
                '                                <div class="col-sm-3">\n' +
                '                                    <label>Company</label>\n' +
                '                                    <input type="text" name="attendees[' + _this.attendeesCount + '][company]" class="form-control" required>\n' +
                '                                </div>\n' +
                '                                <div class="col-sm-2">\n' +
                '                                    <label>Phone</label>\n' +
                '                                    <input type="text" name="attendees[' + _this.attendeesCount + '][phone]" class="form-control" required>\n' +
                '                                </div>\n' +
                '                                <div class="col-sm-2">\n' +
                '                                    <label>Email</label>\n' +
                '                                    <input type="text" name="attendees[' + _this.attendeesCount + '][email]" class="form-control" required>\n' +
                '                                </div>\n' +
                '                                <div class="col-sm-1">\n' +
                '                                    <button type="button" class="btn btn-danger remove-attendee mt-2"><i class="fa fa-trash"></i></button>\n' +
                '                                </div>\n' +
                '                            </div>';

            container.append(html);
        });
    },

    removeAttendee: function () {
        $(document).on('click', '.remove-attendee', function () {
            $(this).closest('.attendee').remove();
        });
    },
};

$().ready(function () {
    window.ManualOrders = ManualOrders;
    window.ManualOrders.init();
});
